<script>
import Axios from 'axios'
import Summernote from './utility/summernote'
import draggable from 'vuedraggable'
import NumberFormatter from './utility/number-formatter'
import Users from './settings/Users'
import MyAccount from './settings/MyAccount'
import BusinessProfile from './settings/BusinessProfile'
import Multiselect from 'vue-multiselect'
import SettingsTriggers from './settings/Triggers'
import Integrations from './settings/Integrations'
import Groups from './settings/Groups'
import Billing from './settings/Billing'
import Sms from './settings/Sms'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'settings',
  data () {
    return {
      invoiceDueDates: [
        { key: 1, name: 'Today' },
        { key: 2, name: 'In 7 Days' },
        { key: 3, name: 'In 14 Days' },
        { key: 4, name: 'In 30 days' },
        { key: 5, name: '1st day of Next Month' },
        { key: 6, name: 'Last day of Next month' },
      ],
      customToolbar: [
        ['bold', 'italic', 'underline'],
      ],
      isAddLocationPressed: 0,
      isSettingsAlreadyLoaded: false,
      filter: '',
      tab: '',
      typingTimer: {},
      typingTimerCEStatusId: null,
      settings: {
        rates: {
          custom: {
            default_rates_rr: 0,
            default_rates_repair: 0,
            default_rates_paint: 0,
            default_rates_paint_material: 'not_set',
            default_rates_mechanical: null,
          },
          ntar: {
            default_rates_rr: 0,
            default_rates_repair: 0,
            default_rates_paint: 0,
            default_rates_paint_material: 'not_set',
            default_rates_mechanical: null,
          },
          ltar: {
            default_rates_rr: 0,
            default_rates_repair: 0,
            default_rates_paint: 0,
            default_rates_paint_material: 'not_set',
            default_rates_mechanical: null,
          },
          rs: {
            default_rates_rr: 0,
            default_rates_repair: 0,
            default_rates_paint: 0,
            default_rates_paint_material: 'not_set',
            default_rates_mechanical: null,
          },
          default: 'custom',
        },
        demo: {
          ids: null,
          enabled: false,
        },
        partssearch: {
          api_key: '',
          enabled: false,
          partssearchDefaultLocation: null,
        },
        estimage: {
          integrationStatus: false,
          cloudIntegrationStatusBySupport: false,
          cloudIntegrationStatus: false,
          integrationStatusBySupport: false,
          configuratorExeVersion: '1.x.x.x',
        },

        claimlinq: {
          api_key: '',
          enabled: false
        },

        estimates: {
          estimate_prefix: '',
          font: '',
          font_size: '10',
          draft_estimate_title: '',
          estimate_title: '',
          ii: {},
          estimate_terms: '',
          email_prefix: '',
          autoSave: true,
          isHideSeries: false,
        },
        cards: {
          card_prefix: '',
          card_number: 1,
          card_number_length: 3,
          font: '',
          font_size: '10',
          card_title: '',
          ce_statuses: [],
        },
        invoices: {
          invoice_prefix: '',
          invoice_number: 1,
          invoice_number_length: 3,
          font: '',
          font_size: '10',
          invoice_title: '',
          ii: {},
          email_prefix: '',
          auto_save: false,
        },
        triggers: [],
        billing: {
          settings: {
            status: false,
            plan_type: 'free',
            plan_id: 0,
            storage_limit: 0,
            storage_addon_id: 0,
            storage_addon_as_needed: false,
            reg_vin_lookup: false,
            reg_vin_lookup_with_build_and_compliance: false,
            reg_vin_lookup_always_on: false,
            sms_messaging: false,
            sms_messaging_incoming: false,
          },
          availablePlans: {
            plans: [
              {
                type: 'free',
                name: 'Free',
                cost: 0
              },
              {
                type: 'paid',
                name: 'Paid',
                cost: 100
              }
            ],
            storages: [
              {
                limit: 10,
                name: '10Gb',
                cost: 50
              },
              {
                limit: 20,
                name: '20Gb',
                cost: 100
              },
            ]
          },
          info: {
            storage: {
              limit: 0,
              consumed: 0
            },
            activeSubscriptions: [],
          }
        },
        maxSmsTextLength: 122,
        sms: {
          sendToCustomer: {
            status: false,
            messageText: '',
          }
        },
      },
      switch: { size: 'small', color: '#3E70C9' },
      nameAddStatus: '',
      fields: [
        {
          label: 'Username',
          key: 'username',
          sortable: true,
          tdClass: 'text-center clickable number',
          thClass: 'text-center bg-navyblue number'
        },
        {
          label: 'Name',
          key: 'full_name',
          sortable: true,
          tdClass: 'text-center clickable card-number',
          thClass: 'text-center bg-navyblue card-number'
        },
        {
          label: 'Email',
          key: 'email',
          sortable: true,
          tdClass: 'text-center clickable number',
          thClass: 'text-center bg-navyblue number'
        },
        {
          label: 'Location',
          key: 'address',
          sortable: true,
          tdClass: 'clickable customer',
          thClass: 'bg-navyblue customer'
        },
        {
          label: 'Work Phone',
          key: 'work_phone',
          sortable: true,
          tdClass: 'text-center clickable rego',
          thClass: 'text-center bg-navyblue rego'
        },
        {
          label: 'Mobile Phone',
          key: 'mobile_phone',
          sortable: true,
          tdClass: 'text-center clickable make',
          thClass: 'text-center bg-navyblue make'
        },
        {
          label: 'Email',
          key: 'email',
          sortable: true,
          tdClass: 'text-center clickable model',
          thClass: 'text-center bg-navyblue model'
        },
        {
          label: 'Role',
          key: 'role',
          sortable: true,
          tdClass: 'text-center clickable colour',
          thClass: 'text-center bg-navyblue colour'
        },
        {
          label: 'Actions',
          key: 'actions',
          sortable: true,
          tdClass: 'text-center clickable insurance',
          thClass: 'text-center bg-navyblue insurance'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      isStatusActive: 'isStatusActive',
      getterBusinessName: 'getBusinessName',
      isRsEnabled: 'isRsEnabled',
    }),
    isActiveParssearchCode () {
      return !!(this.settings && this.settings.partssearch && this.settings.partssearch.api_key && this.settings.partssearch.enabled)
    },
    isSetDefaultPSLoc () {
      return !!(this.settings && this.settings.partssearch && this.settings.partssearch.partssearchDefaultLocation)
    },
    defaultPSLocId () {
      return this.settings.partssearch.partssearchDefaultLocation
    },
    computedSettingsEstimatesAutoSave: {
      get () {
        // console.log('autoSave====',JSON.stringify(this.settings.estimates.autoSave));
        if (this.settings.estimates.autoSave) {
          return true
        }
        if (this.settings.estimates.autoSave === false) {
          return false
        }
        return true
      },
      set (val) {
        //console.log('autoSave',JSON.stringify(val));
        this.settings.estimates.autoSave = val
      }
    },
    computedEstimatesRatesCustomPaintMaterial: {
      get () {
        let vm = this
        try {
          let item = _.find([{ value: 'S1', label: 'S1' }, { value: 'S2', label: 'S2' }, {
            value: 'M1',
            label: 'M1'
          }, { value: 'M2', label: 'M2' }, { value: 'M3', label: 'M3' }, {
            value: 'M3PLUS',
            label: 'M3+'
          }], function (itm) {
            return itm.value === vm.settings.rates.custom.default_rates_paint_material
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set (value) {
        this.settings.rates.custom.default_rates_paint_material = value.label
        //console.log('1', this.settings.rates.custom.default_rates_paint_material);
      },
    },
    computedEstimatesRatesNTARPaintMaterial: {
      get () {
        let vm = this
        try {
          let item = _.find([{ value: 'S1', label: 'S1' }, { value: 'S2', label: 'S2' }, {
            value: 'M1',
            label: 'M1'
          }, { value: 'M2', label: 'M2' }, { value: 'M3', label: 'M3' }, {
            value: 'M3PLUS',
            label: 'M3+'
          }], function (itm) {
            return itm.value === vm.settings.rates.ntar.default_rates_paint_material
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set (value) {
        this.settings.rates.ntar.default_rates_paint_material = value.label
        //console.log('1', this.settings.rates.ntar.default_rates_paint_material);
      },
    },
    computedEstimatesRatesLTARPaintMaterial: {
      get () {
        let vm = this
        try {
          let item = _.find([{ value: 'S1', label: 'S1' }, { value: 'S2', label: 'S2' }, {
            value: 'M1',
            label: 'M1'
          }, { value: 'M2', label: 'M2' }, { value: 'M3', label: 'M3' }, {
            value: 'M3PLUS',
            label: 'M3+'
          }], function (itm) {
            return itm.value === vm.settings.rates.ltar.default_rates_paint_material
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set (value) {
        this.settings.rates.ltar.default_rates_paint_material = value.label
        //console.log('1', this.settings.rates.ltar.default_rates_paint_material);
      },
    },
    computedEstimatesRatesRSPaintMaterial: {
      get () {
        let vm = this
        try {
          let item = _.find([{ value: 'S1', label: 'S1' }, { value: 'S2', label: 'S2' }, {
            value: 'M1',
            label: 'M1'
          }, { value: 'M2', label: 'M2' }, { value: 'M3', label: 'M3' }, {
            value: 'M3PLUS',
            label: 'M3+'
          }], function (itm) {
            return itm.value === vm.settings.rates.rs.default_rates_paint_material
          })
          return item
        } catch (e) {
          return {}
        }
      },
      set (value) {
        this.settings.rates.rs.default_rates_paint_material = value.label
        //console.log('1', this.settings.rates.ltar.default_rates_paint_material);
      },
    },
    isDefaultMethodologyCustom: function () {
      if (this.settings.rates.default == 'custom') {
        return true
      }
      return false
    },
    isDefaultMethodologyNTAR: function () {
      if (this.settings.rates.default == 'ntar') {
        return true
      }
      return false
    },
    isDefaultMethodologyLTAR: function () {
      if (this.settings.rates.default == 'ltar') {
        return true
      }
      return false
    },
    isDefaultMethodologyRS: function () {
      return Boolean(this.isRsEnabled && this.settings.rates.default == 'rs')
    },
  },
  methods: {
    onTabChange () {
      $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
        this.tab = $(e.target).attr('href')
        let route = '', params = ''
        if (this.tab === '#users') {
          route = 'users'
          this.$storage.set('views.advancedSettings.defaultView', 'users')
        } else if (this.tab === '#business-profile') {
          route = 'business-profile'
          this.$storage.set('views.advancedSettings.defaultView', 'business-profile')
        } else if (this.tab === '#integrations') {
          route = 'integrations'
          this.$storage.set('views.advancedSettings.defaultView', 'integrations')
        } else if (this.tab === '#groups') {
          route = 'groups'
          this.$storage.set('views.advancedSettings.defaultView', 'groups')
        } else if (this.tab === '#my-account') {
          route = 'my-account'
          this.$storage.set('views.advancedSettings.defaultView', 'my-account')
        } else if (this.tab === '#methodology') {
          route = 'methodology'
          this.$storage.set('views.advancedSettings.defaultView', 'methodology')
        } else if (this.tab === '#estimates') {
          route = 'estimates'
          this.$storage.set('views.advancedSettings.defaultView', 'estimates')
        } else if (this.tab === '#cards') {
          route = 'cards'
          this.$storage.set('views.advancedSettings.defaultView', 'cards')
        } else if (this.tab === '#invoices') {
          route = 'invoices'
          this.$storage.set('views.advancedSettings.defaultView', 'invoices')
        } else if (this.tab === '#billing') {
          route = 'billing'
          this.$storage.set('views.advancedSettings.defaultView', 'billing')
        } else if (this.tab === '#sms') {
          route = 'sms'
          this.$storage.set('views.advancedSettings.defaultView', 'sms')
        }
        if (route === 'integrations') {
          let subTab = 'partssearch'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.integrations.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.integrations.defaultView')
          }
          let params = { name: 'integrations', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (route === 'billing') {
          let subTab = 'settings'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.billing.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.billing.defaultView')
          }
          let params = { name: 'integrations', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (route === 'business-profile') {
          let subTab = 'details'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.business.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.business.defaultView')
          }
          let params = { name: 'business', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else {
          params = (route) ? { name: 'settings', params: { tab: route } } : '/settings'
          this.$router.push(params).catch(() => {})
        }
      })
    },
    onClickAddLocation: function () {
      this.isAddLocationPressed++
    },
    addNewUser () {
      this.$refs.users.onClickAddNewUser()
    },
    isDefaultMethodology: function (t) {
      if (this.settings.rates.default == t) {
        return true
      }
      return false
    },
    setDefaultMethodology: function (t) {
      this.settings.rates.default = t
    },
    isTabActive: function (tab) {
      let url = this.$route.path
      //console.log('this.tab', this.tab);
      //console.log('tab', tab);
      //console.log('url', url);
      if (this.tab === '#integrations' && tab === 'integrations' && url.includes('/settings/integrations')) {
        return true
      } else if (this.tab === '#users' && tab === 'users' && url === '/settings/users') {
        return true
      } else if (this.tab === '#groups' && tab === 'groups' && url === '/settings/groups') {
        return true
      } else if (this.tab === '#business-profile' && url.includes('/settings/business-profile') && tab === 'business-profile') {
        return true
      } else if (this.tab === '#my-account' && url === '/settings/my-account' && tab === 'my-account') {
        return true
      } else if (this.tab === '#methodology' && url === '/settings/methodology' && tab === 'methodology') {
        return true
      } else if (this.tab === '#estimates' && url === '/settings/estimates' && tab === 'estimates') {
        return true
      } else if (this.tab === '#cards' && url === '/settings/cards' && tab === 'cards') {
        return true
      } else if (this.tab === '#invoices' && url === '/settings/invoices' && tab === 'invoices') {
        return true
      } else if (this.tab === '#billing' && url.includes('/settings/billing') && tab === 'billing') {
        return true
      } else if (this.tab === '#sms' && url === '/settings/sms' && tab === 'sms') {
        return true
      }
      return false
    },
    clickAddCEStatus () {
      NProgress.start()
      this.$store.dispatch('addNewCEStatus', { status_name: this.nameAddStatus })
          .then(response => {
            NProgress.done()
            if (response.status !== 200) {
              toastr.error(response.data.msg)
            } else {
              toastr.success(response.data.msg.msg)
              this.settings.cards.ce_statuses.push(response.data.msg.firstStatus)
              this.nameAddStatus = ''
            }
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    clickDeleteCEStatus (status_id) {
      if (this.typingTimerCEStatusId === status_id) {
        clearTimeout(this.typingTimer)
      }
      NProgress.start()
      this.$store.dispatch('deleteCEStatus', { CEStatus_id: status_id })
          .then(response => {
            this.typingTimerCEStatusId = null
            NProgress.done()
            if (response.status !== 200) {
              toastr.error(response.data.msg)
            } else {
              toastr.success(response.data.msg.msg)
              this.settings.cards.ce_statuses.forEach((status, i) => {
                if (status.ce_status_id === response.data.msg.CEStatus_id) {
                  this.settings.cards.ce_statuses.splice(i, 1)
                }
              })
            }
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
    },
    updateDemoData () {
      this.updateSettings()
    },
    updateSettings: function () {
      //this.settings.estimage.enabled = this.es.checked;
      //this.settings.partssearch.enabled = this.ps.checked;
      //this.settings.xero.enabled = this.xr.checked;
      //this.settings.myob.enabled = this.my.checked;
      //this.settings.pnet_suncorp.enabled = this.pn.checked;
      NProgress.start()
      Axios.post('/fe/settings/vendor', this.settings)
          .then(response => {
            NProgress.done()
            toastr.success(response.data.msg)
          })
          .catch(error => {
            NProgress.done()
            toastr.error(error)
          })
          .finally(() => {
            if (this.tab === '#integrations' && this.$route.params.tab === 'partssearch') {
              this.$store.dispatch('loadPartsSearchLocation')
            }
          })
      if (this.$refs['triggers-table']) {
        this.$refs['triggers-table'].saveData()
      }

    },
    hasTrigger (index) {
      return this.cardsStatuses[index].triggers && this.cardsStatuses[index].triggers.length > 0
    },
    handleTriggerClick (index) {
      if (this.hasTrigger(index)) {
        this.cardsStatuses[index]._details = !this.cardsStatuses[index]._details
      }
    },
    handleAddStatus () {
      if (this.nameAddStatus === '') return

      this.cardsStatuses.push({
        ce_status_id: this.cardsStatuses.length,
        vendor_id: '2',
        original_name: this.nameAddStatus.trim(),
        name: this.nameAddStatus.trim(),
        dynamic_name: '1',
        dynamic_order: '1',
        order_number: this.cardsStatuses.length,
        _details: false,
        _is_edit: false,
        triggers: []
      })
      this.nameAddStatus = ''
    },
    setUrl () {
      let url = this.$route.path

      if (url.includes('/settings/integrations')) {
        this.tab = '#integrations'
      } else if (url === '/settings/users') {
        this.tab = '#users'
      } else if (url === '/settings/groups') {
        this.tab = '#groups'
      } else if (url.includes('/settings/business-profile')) {
        this.tab = '#business-profile'
      } else if (url === '/settings/my-account') {
        this.tab = '#my-account'
      } else if (url === '/settings/methodology') {
        this.tab = '#methodology'
      } else if (url === '/settings/estimates') {
        this.tab = '#estimates'
      } else if (url === '/settings/cards') {
        this.tab = '#cards'
      } else if (url === '/settings/invoices') {
        this.tab = '#invoices'
      } else if (url.includes('/settings/billing')) {
        this.tab = '#billing'
      } else if (url === '/settings/billing') {
        this.tab = '#billing'
      } else if (url === '/settings/sms') {
        this.tab = '#sms'
      }

    },
    selectInvoiceOption (value, id) {
      console.log('selectInvoiceOption', value, id, arguments)
    },
    selectEstimatesOption (value, id) {
      console.log('selectEstimatesOption', value, id, arguments)
    },
    loadVendorSettings (toastrText = false) {
      this.isSettingsAlreadyLoaded = false
      NProgress.start()
      Axios.get('/fe/settings/vendor')
          .then(response => {
            if (response.data) {
              this.settings = response.data
              if (!this.settings.estimates.ii) {
                this.settings.estimates.ii = {
                  show_tax_number: false,
                  show_col_headings: false,
                  show_item_code: false,
                  show_unit_price_qty: false,
                  show_payment_advice: false,
                  show_address: false,
                  show_tax_column: false,
                  show_logo: false,
                  hide_discount: false,
                  show_contact_number: false,
                  show_payment_service: false
                }
              }

              if (!this.settings.invoices.ii) {
                this.settings.invoices.ii = {
                  show_tax_number: false,
                  show_col_headings: false,
                  show_item_code: false,
                  show_unit_price_qty: false,
                  show_payment_advice: false,
                  show_address: false,
                  show_tax_column: false,
                  show_logo: false,
                  hide_discount: false,
                  show_contact_number: false,
                  show_payment_service: false,
                  advice: ''
                }
              }

              if (toastrText) {
                toastr.success('Your change to play type ' + toastrText + ' has been successful')
              }
            }
          })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
            this.isSettingsAlreadyLoaded = true
          })
    },
  },
  mounted: function () {
    if (this.isEstimatorUser) {
      let params = { name: 'settings', params: { tab: 'my-account' } }
      this.$router.push(params).catch(() => {})
    } else if (this.$route.params.customTab) {
      if (this.$route.params.customSubTab !== '') {
        if (this.$route.params.customTab === 'business-profile') {
          let params = { name: 'business', params: { tab: this.$route.params.customSubTab } }
          this.$router.push(params).catch(() => {})
          this.$storage.set('views.advancedSettings.defaultView', 'business-profile')
        }
      } else {
        this.$storage.set('views.advancedSettings.defaultView', this.$route.params.customTab)
        let params = { name: 'settings', params: { tab: this.$route.params.customTab } }
        this.$router.push(params).catch(() => {})
      }
    } else if (!_.isEmpty(this.$storage.get('views.advancedSettings.defaultView'))) {
      let currentTab = ''
      currentTab = this.$storage.get('views.advancedSettings.defaultView')
      let resultPath = '/settings/' + currentTab
      if (this.$route.path !== resultPath) {
        if (currentTab === 'integrations') {
          let subTab = 'partssearch'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.integrations.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.integrations.defaultView')
          }
          let params = { name: 'integrations', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (currentTab === 'business-profile') {
          let subTab = 'details'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.business.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.business.defaultView')
          }
          let params = { name: 'business', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (currentTab === 'billing') {
          let subTab = 'settings'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.billing.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.billing.defaultView')
          }
          let params = { name: 'billing', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else {
          this.$router.push({ name: 'settings', params: { tab: currentTab } }).catch(() => {})
        }
      }
    } else {
      let path = this.$route.path.split('/')
      let tab = path[path.length - 1]
      if (path[path.length - 2] === 'integrations') {
        let params = { name: 'integrations', params: { tab: path[path.length - 1] } }
        this.$router.push(params).catch(() => {})
      } else if (path[path.length - 2] === 'business-profile') {
        let params = { name: 'business', params: { tab: path[path.length - 1] } }
        this.$router.push(params).catch(() => {})
      } else if (path[path.length - 2] === 'billing') {
        let params = { name: 'billing', params: { tab: path[path.length - 1] } }
        this.$router.push(params).catch(() => {})
      } else if (tab === 'integrations' || tab === 'cards' || tab === 'estimates' ||
          tab === 'invoices' || tab === 'users' || tab === 'groups' ||
          tab === 'my-account' || tab === 'business-profile' || tab === 'billing' || tab === 'sms') {

        if (tab === 'integrations') {
          let subTab = 'partssearch'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.integrations.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.integrations.defaultView')
          }
          let params = { name: 'integrations', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (tab === 'business-profile') {
          let subTab = 'details'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.business.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.business.defaultView')
          }
          let params = { name: 'business', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else if (tab === 'billing') {
          let subTab = 'settings'
          if (!_.isEmpty(this.$storage.get('views.advancedSettings.billing.defaultView'))) {
            subTab = this.$storage.get('views.advancedSettings.billing.defaultView')
          }
          let params = { name: 'billing', params: { tab: subTab } }
          this.$router.push(params).catch(() => {})
        } else {
          this.$router.push({ name: 'settings', params: { tab: tab } }).catch(() => {})
        }
      } else {
        let params = { name: 'integrations', params: { tab: 'partssearch' } }
        this.$router.push(params).catch(() => {})
      }
    }

    this.setUrl()

    if (this.isShopManagerUser) {

      this.loadVendorSettings()

      // $('#invoice_payment_advice').summernote({airMode: true})

    }
  },
  watch: {
    isShopManagerUser (newVal) {
      if (newVal && !this.isSettingsAlreadyLoaded) {
        this.loadVendorSettings()
      }
    },
  },
  components: {
    Summernote,
    draggable,
    NumberFormatter,
    Users,
    MyAccount,
    BusinessProfile,
    Multiselect,
    Integrations,
    SettingsTriggers,
    Groups,
    Billing,
    Sms,
    VueEditor,
  }
}
</script>

<template>
  <div>
    <div class="page-header">
      <h4>Advanced Settings</h4>
      <ol class="breadcrumbs">
        <li class="breadcrumb-item home">
          <router-link to="/">Home</router-link>
        </li>
        <li class="breadcrumb-item active">Advanced Settings</li>
      </ol>
      <h4 class="header-display-name">{{ getterBusinessName }}</h4>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-block bg-white">
          <div>
            <div>
              <div class="setting-card">
                <div class="tabs-component">
                  <ul class="tab-header nav nav-tabs nav-tabs-2 float-sm-left btn-right-padding">
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('cards')}" data-toggle="tab" @click="onTabChange"
                           href="#cards">Cards</a>
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('estimates')}" data-toggle="tab"
                           @click.prevent="onTabChange"
                           href="#estimates">Estimates</a>
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('invoices')}" data-toggle="tab"
                           @click.prevent="onTabChange"
                           href="#invoices">Invoices</a>
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('users')}" data-toggle="tab" @click.prevent="onTabChange"
                           href="#users">Users</a>
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('groups')}" data-toggle="tab" @click.prevent="onTabChange"
                           href="#groups">Groups</a>
                      </li>
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('integrations')}" @click="onTabChange"
                           data-toggle="tab" href="#integrations">Integrations</a>
                      </li>
                    </template>
                    <li class="tabs-component-tab nav-item"
                        v-if="isShopManagerUser || isCustomerUser || isProductionManagerUser">
                      <a class="tabs-component-tab-a nav-link"
                         v-bind:class="{active: isTabActive('sms')}" data-toggle="tab" @click="onTabChange"
                         href="#sms">SMS</a>
                    </li>
                    <li class="tabs-component-tab nav-item">
                      <a class="tabs-component-tab-a nav-link"
                         v-bind:class="{active: isTabActive('my-account')}" data-toggle="tab"
                         @click.prevent="onTabChange"
                         href="#my-account">My Account</a>
                    </li>
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('business-profile')}" @click.prevent="onTabChange"
                           data-toggle="tab" href="#business-profile">Business Profile</a>
                      </li>
                    </template>
                    <template v-if="isShopManagerUser">
                      <li class="tabs-component-tab nav-item">
                        <a class="tabs-component-tab-a nav-link"
                           v-bind:class="{active: isTabActive('billing')}" @click.prevent="onTabChange"
                           data-toggle="tab" href="#billing">Billing</a>
                      </li>
                    </template>
                  </ul>
                  <div class="tab-header rs-btn-group float-sm-right mt-1-sm">
                    <div class="tabs-nav-right-btn">
                      <button @click="updateSettings"
                              v-if="tab!=='#users' && tab!=='#my-account' && tab!=='#business-profile' && isStatusActive"
                              class="btn btn-primary w-min-sm waves-effect waves-light ml-1 my-1">Save
                      </button>
                      <a v-if="tab==='#users' && isStatusActive" href="#" @click.prevent="addNewUser"
                         class="btn btn-primary w-min-sm waves-effect waves-light ml-1 font-weight-bold my-1">
                        <i class="ti-plus add-user"></i>
                        New User
                      </a>
                      <a v-if="tab === '#business-profile' && $storage.get('views.advancedSettings.business.defaultView') === 'locations'"
                         href="#" @click.prevent="onClickAddLocation"
                         class="btn btn-primary w-min-sm waves-effect waves-light ml-1 font-weight-bold">
                        <i class="ti-plus add-user"></i>
                        Add Location
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-block tab-content row no-gutter">
                  <template v-if="isShopManagerUser">
                    <div v-if="isTabActive('integrations')" style="width: 100%" id="integrations"
                         class="tab-pane col-lg-6 col-md-6"
                         v-bind:class="{active: isTabActive('integrations')}" role="tabpanel">
                      <integrations ref="integrations" v-model="settings"></integrations>
                    </div>
                    <div style="padding-left: 15px" id="methodology" class="tab-pane col-lg-6 col-md-6"
                         v-bind:class="{active: isTabActive('methodology')}" role="tabpanel">
                    </div>

                    <div v-if="isTabActive('estimates')" style="padding-left: 15px" id="estimates"
                         class="tab-pane tab-pane--estimates col-12"
                         v-bind:class="{active: isTabActive('estimates')}"
                         role="tabpanel">

                      <div class="row no-gutter">
                        <div class="col-sm-6">
                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Estimate - Standard</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label for="estimate_prefix" class="col-sm-4 col-form-label">Estimate Prefix</label>
                                <div class="col-sm-8">
                                  <input v-model="settings.estimates.estimate_prefix"
                                         :readonly="!isStatusActive"
                                         type="text"
                                         class="form-control" id="estimate_prefix"
                                         placeholder="Estimate Prefix">
                                </div>
                              </div>
                              <!--<div class="form-group row no-gutter">
                                  <label for="ii" class="col-sm-4 col-form-label">Information Included</label>
                                  <div class="col-sm-8">
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_tax_number"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_tax_number"
                                                     type="checkbox"
                                                     name="ii_show_tax_number"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Tax Number</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_col_headings"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_col_headings"
                                                     type="checkbox"
                                                     name="ii_show_col_headings"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Column Headings</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_item_code"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_item_code"
                                                     type="checkbox"
                                                     name="ii_show_item_code"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Item Coode</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_unit_price_qty"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_unit_price_qty"
                                                     type="checkbox"
                                                     name="ii_show_unit_price_qty"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Unit Price and Quantity</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_payment_advice"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_payment_advice"
                                                     type="checkbox"
                                                     name="ii_show_payment_advice"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Payment Advice Cut away</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_address"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_address"
                                                     type="checkbox"
                                                     name="ii_show_address"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Address</span>
                                          </label>
                                      </div>

                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_address"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_address"
                                                     type="checkbox"
                                                     name="ii_show_address"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Address</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_tax_column"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_tax_column"
                                                     type="checkbox"
                                                     name="ii_show_tax_column"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Tax Column</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_logo"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_logo"
                                                     type="checkbox"
                                                     name="ii_show_logo"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Logo</span>
                                          </label>
                                      </div>

                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_hide_discount"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.hide_discount"
                                                     type="checkbox"
                                                     name="ii_hide_discount"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Hide Discount</span>
                                          </label>
                                      </div>

                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_contact_number"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_contact_number"
                                                     type="checkbox"
                                                     name="ii_show_contact_number"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Contact Number</span>
                                          </label>
                                      </div>

                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_payment_service"
                                                     class="form-check-input"
                                                     v-model="settings.estimates.ii.show_payment_service"
                                                     type="checkbox"
                                                     name="ii_show_payment_service"
                                                     value="true"
                                                     @change="selectEstimatesOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Payment Service</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>-->
                              <div class="form-group row no-gutter">
                                <label for="estimate_terms" class="col-sm-4 col-form-label">Terms Estimate</label>
                                <div class="col-sm-8">
                                                                  <textarea class="terms-editor"
                                                                            v-model="settings.estimates.estimate_terms"
                                                                            cols="30" rows="10">
                                                                  </textarea>
                                </div>
                              </div>

                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Hide Series name <br/> from Estimate</label>
                                <div class="col-sm-8">
                                  <label class="form-check-inline checkbox" style="padding-top: 8px;">
                                    <input :disabled="!isStatusActive" class="form-check-input"
                                           name="hide-series-checkbox" v-model="settings.estimates.isHideSeries"
                                           type="checkbox">
                                    <span class="icon"><i class='bx bx-check'></i></span><span class="text"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Auto Save</strong>
                            </div>
                            <div class="card-block bg-white">
                              <label class="col-sm-4 col-form-label" style="padding-left: 0px;"> Auto-Save</label>
                              <toggle-button
                                  v-model="computedSettingsEstimatesAutoSave"
                                  class="mb-0 rs-toggle__button"
                                  color="#5E79FF"
                                  :width="40"
                                  :disabled="!isStatusActive"
                                  :sync="true"
                                  :labels="false"/>
                              <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                                                            <template
                                                                v-if="computedSettingsEstimatesAutoSave">Active</template>
                                                            <template v-else>Not Active</template>
                                                        </span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6 pl-1">

                          <!-- Custom Rates -->
                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Rates</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Estimate Methodology</label>
                                <div class="col-sm-8">
                                  <input readonly value="Custom" class="form-control">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">RR</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="rr"
                                                    v-model="settings.rates.custom.default_rates_rr"
                                                    type="text"
                                                    class="form-control"
                                                    :isDisabled="!isStatusActive"
                                                    placeholder="RR Amount"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Repair</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="repair" type="text"
                                                    v-model="settings.rates.custom.default_rates_repair"
                                                    class="form-control" id="repair"
                                                    placeholder="Repair"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="paint" type="text"
                                                    v-model="settings.rates.custom.default_rates_paint"
                                                    class="form-control" id="paint"
                                                    placeholder="Paint"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint Material</label>
                                <div class="col-sm-8">
                                  <multiselect id="custom_default_rates_paint_material"
                                               v-model="computedEstimatesRatesCustomPaintMaterial"
                                               :options="[{value: 'S1', label: 'S1'}, {value:'S2', label: 'S2'}, {value:'M1', label: 'M1'}, {value:'M2', label: 'M2'}, {value:'M3', label: 'M3'}, { value: 'M3PLUS', label: 'M3+'}]"
                                               label="label"
                                               track-by="value"
                                               :showLabels="false"
                                               :disabled="!isStatusActive"
                                               style="opacity: 1"
                                               :option-height="31.5"
                                               :close-on-select="true"
                                  >
                                  </multiselect>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Mechanical</label>
                                <div class="col-sm-8">
                                  <number-formatter type="text"
                                                    class="form-control" id="mechanical"
                                                    placeholder="Mechanical"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                                    v-model="settings.rates.custom.default_rates_mechanical"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="row no-gutter mt-2">
                                <div class="form-check">
                                  <label class="form-check-inline checkbox w-100">
                                    <input class="form-check-input"
                                           :checked="isDefaultMethodologyCustom"
                                           :disabled="isDefaultMethodologyCustom || !isStatusActive"
                                           type="checkbox"
                                           name="DefaultMethodologyCustom"
                                           value="true"
                                           @change="setDefaultMethodology('custom')">
                                    <span class="icon"><i class='bx bx-check'></i></span>
                                    <span class="text">Make this my default for new Estimate</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- NTAR Rates -->
                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Rates</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Estimate Methodology</label>
                                <div class="col-sm-8">
                                  <input readonly value="NTAR" class="form-control" :readonly="!isStatusActive">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">RR</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="rr"
                                                    v-model="settings.rates.ntar.default_rates_rr"
                                                    type="text"
                                                    class="form-control"
                                                    :isDisabled="!isStatusActive"
                                                    placeholder="RR Amount"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Repair</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="repair" type="text"
                                                    v-model="settings.rates.ntar.default_rates_repair"
                                                    class="form-control" id="repair"
                                                    placeholder="Repair"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="paint" type="text"
                                                    v-model="settings.rates.ntar.default_rates_paint"
                                                    class="form-control" id="paint"
                                                    placeholder="Paint"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint Material</label>
                                <div class="col-sm-8">
                                  <multiselect id="ntar_default_rates_paint_material"
                                               v-model="computedEstimatesRatesNTARPaintMaterial"
                                               :options="[{value: 'S1', label: 'S1'}, {value:'S2', label: 'S2'}, {value:'M1', label: 'M1'}, {value:'M2', label: 'M2'}, {value:'M3', label: 'M3'}, { value: 'M3PLUS', label: 'M3+'}]"
                                               label="label"
                                               track-by="value"
                                               :showLabels="false"
                                               :option-height="31.5"
                                               :disabled="!isStatusActive"
                                               style="opacity: 1"
                                               :close-on-select="true"
                                               @select="selectEstimatesOption">
                                  </multiselect>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Mechanical</label>
                                <div class="col-sm-8">
                                  <number-formatter type="text"
                                                    class="form-control" id="mechanical"
                                                    placeholder="Mechanical"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                                    v-model="settings.rates.ntar.default_rates_mechanical"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="row no-gutter mt-2">
                                <div class="form-check">
                                  <label class="form-check-inline checkbox w-100">
                                    <input class="form-check-input"
                                           :checked="isDefaultMethodologyNTAR"
                                           :disabled="isDefaultMethodologyNTAR || !isStatusActive"
                                           type="checkbox"
                                           name="DefaultMethodologyNTAR"
                                           value="true"
                                           @change="setDefaultMethodology('ntar')">
                                    <span class="icon"><i class='bx bx-check'></i></span>
                                    <span class="text">Make this my default for new Estimate</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- LTAR Rates -->
                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Rates</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Estimate Methodology</label>
                                <div class="col-sm-8">
                                  <input readonly value="LTAR" class="form-control">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">RR</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="rr"
                                                    :isDisabled="!isStatusActive"
                                                    v-model="settings.rates.ltar.default_rates_rr"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="RR Amount"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Repair</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="repair" type="text"
                                                    :isDisabled="!isStatusActive"
                                                    v-model="settings.rates.ltar.default_rates_repair"
                                                    class="form-control" id="repair"
                                                    placeholder="Repair"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="paint" type="text"
                                                    :isDisabled="!isStatusActive"
                                                    v-model="settings.rates.ltar.default_rates_paint"
                                                    class="form-control" placeholder="Paint"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint Material</label>
                                <div class="col-sm-8">
                                  <multiselect id="ltar_default_rates_paint_material"
                                               ref="RatesPaintMaterial"
                                               :disabled="!isStatusActive"
                                               style="opacity: 1"
                                               v-model="computedEstimatesRatesLTARPaintMaterial"
                                               :options="[{value: 'S1', label: 'S1'}, {value:'S2', label: 'S2'}, {value:'M1', label: 'M1'}, {value:'M2', label: 'M2'}, {value:'M3', label: 'M3'}, { value: 'M3PLUS', label: 'M3+'}]"
                                               label="label"
                                               track-by="value"
                                               :showLabels="false"
                                               :option-height="31.5"
                                               :close-on-select="true"
                                               @select="selectEstimatesOption">
                                  </multiselect>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Mechanical</label>
                                <div class="col-sm-8">
                                  <number-formatter type="text"
                                                    class="form-control" id="mechanical"
                                                    placeholder="Mechanical"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                                    v-model="settings.rates.ltar.default_rates_mechanical"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="row no-gutter mt-2">
                                <div class="form-check">
                                  <label class="form-check-inline checkbox w-100">
                                    <input class="form-check-input"
                                           :checked="isDefaultMethodologyLTAR"
                                           :disabled="isDefaultMethodologyLTAR || !isStatusActive"
                                           type="checkbox"
                                           name="DefaultMethodologyLTAR"
                                           value="true"
                                           @change="setDefaultMethodology('ltar')">
                                    <span class="icon"><i class='bx bx-check'></i></span>
                                    <span class="text">Make this my default for new Estimate</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- RS Rates -->
                          <div v-if="isRsEnabled" class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Rates</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Estimate Methodology</label>
                                <div class="col-sm-8">
                                  <input readonly value="RS" class="form-control">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">RR</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="rr"
                                                    v-model="settings.rates.rs.default_rates_rr"
                                                    type="text"
                                                    :isDisabled="!isStatusActive"
                                                    class="form-control"
                                                    placeholder="RR Amount"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Repair</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="repair" type="text"
                                                    v-model="settings.rates.rs.default_rates_repair"
                                                    class="form-control"
                                                    placeholder="Repair"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint</label>
                                <div class="col-sm-8">
                                  <number-formatter ref="paint" type="text"
                                                    v-model="settings.rates.rs.default_rates_paint"
                                                    class="form-control" placeholder="Paint"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Paint Material</label>
                                <div class="col-sm-8">
                                  <multiselect
                                      ref="RatesPaintMaterial"
                                      v-model="computedEstimatesRatesRSPaintMaterial"
                                      :options="[{value: 'S1', label: 'S1'}, {value:'S2', label: 'S2'}, {value:'M1', label: 'M1'}, {value:'M2', label: 'M2'}, {value:'M3', label: 'M3'}, { value: 'M3PLUS', label: 'M3+'}]"
                                      label="label"
                                      track-by="value"
                                      :showLabels="false"
                                      :option-height="31.5"
                                      :disabled="!isStatusActive"
                                      style="opacity: 1"
                                      :close-on-select="true"
                                      @select="selectEstimatesOption">
                                  </multiselect>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Mechanical</label>
                                <div class="col-sm-8">
                                  <number-formatter type="text"
                                                    class="form-control" id="mechanical"
                                                    placeholder="Mechanical"
                                                    :isDisabled="!isStatusActive"
                                                    format="$0,0.00"
                                                    v-model="settings.rates.rs.default_rates_mechanical"
                                  ></number-formatter>
                                </div>
                              </div>
                              <div class="row no-gutter mt-2">
                                <div class="form-check">
                                  <label class="form-check-inline checkbox w-100">
                                    <input class="form-check-input"
                                           :checked="isDefaultMethodologyRS"
                                           :disabled="isDefaultMethodologyRS || !isStatusActive"
                                           type="checkbox"
                                           name="DefaultMethodologyRS"
                                           value="true"
                                           @change="setDefaultMethodology('rs')">
                                    <span class="icon"><i class='bx bx-check'></i></span>
                                    <span class="text">Make this my default for new Estimate</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>

                    <div v-if="isTabActive('cards')" style="padding-left: 15px" id="cards" class="tab-pane col-12"
                         v-bind:class="{active: isTabActive('cards')}" role="tabpanel">
                      <div class="row no-gutter">
                        <div class="col-12 col-md-3">
                          <div class="card">
                            <div class="card-header bg-navyblue">Cards - Standard</div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label for="card_prefix"
                                       class="col-lg-5 col-form-label">Card
                                  Prefix</label>
                                <div class="col-lg-7">
                                  <input v-model="settings.cards.card_prefix"
                                         type="text"
                                         :readonly="!isStatusActive"
                                         class="form-control" id="card_prefix"
                                         placeholder="Card Prefix">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label for="card_number"
                                       class="col-lg-5 col-form-label">Card
                                  Number Start</label>
                                <div class="col-lg-7">
                                  <input v-model="settings.cards.card_number"
                                         type="text"
                                         :readonly="!isStatusActive"
                                         class="form-control" id="card_number"
                                         placeholder="Card Number Start">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label for="card_number_length"
                                       class="col-lg-5 col-form-label">Card Number
                                  Length</label>
                                <div class="col-lg-7">
                                  <multiselect
                                      v-model="settings.cards.card_number_length"
                                      :options="['1','2','3','4','5','6','7','8','9','10']"
                                      :showLabels="false"
                                      :option-height="29"
                                      :disabled="!isStatusActive"
                                      style="opacity: 1"
                                      :max-height="203"
                                      :close-on-select="true"
                                  ></multiselect>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-9">
                          <div class="card">
                            <div class="card-header bg-navyblue">Cards - Status</div>

                            <div class="card-block bg-white p-0">
                              <settings-triggers ref="triggers-table" :triggers="settings.triggers"></settings-triggers>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="invoices"
                         v-if="isTabActive('invoices')"
                         class="tab-pane tab-pane--invoices col-lg-12 col-md-12"
                         v-bind:class="{active: isTabActive('invoices')}"
                         role="tabpanel">

                      <div class="row no-gutter">
                        <div class="col-sm-6">
                          <div class="card">
                            <div class="card-header bg-navyblue">
                              <strong>Invoice Standard</strong>
                            </div>
                            <div class="card-block bg-white">
                              <div class="form-group row no-gutter">
                                <label for="invoice_prefix" class="col-sm-4 col-form-label">Invoice Prefix</label>
                                <div class="col-sm-8">
                                  <input v-model="settings.invoices.invoice_prefix"
                                         type="text"
                                         class="form-control"
                                         :readonly="!isStatusActive"
                                         id="invoice_prefix"
                                         placeholder="Invoice Prefix">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label for="invoice_number" class="col-sm-4 col-form-label">Invoice Number Start</label>
                                <div class="col-sm-8">
                                  <input v-model="settings.invoices.invoice_number"
                                         type="text"
                                         :readonly="!isStatusActive"
                                         class="form-control" id="invoice_number"
                                         placeholder="Invoice Number Start">
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label for="invoice_number_length" class="col-sm-4 col-form-label">Invoice Number
                                  Length</label>
                                <div class="col-sm-8">
                                  <multiselect id="invoice_number_length"
                                               v-model="settings.invoices.invoice_number_length"
                                               :options="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']"
                                               :showLabels="false"
                                               :disabled="!isStatusActive"
                                               style="opacity: 1"
                                               :option-height="29"
                                               :close-on-select="true"
                                               @select="selectInvoiceOption">
                                  </multiselect>
                                </div>
                              </div>
                              <div class="form-group row no-gutter">
                                <label class="col-sm-4 col-form-label">Due Date - (Default)</label>
                                <div class="col-sm-8">
                                  <multiselect
                                      v-model="settings.invoices.invoiceDueDate"
                                      :options="invoiceDueDates.map(date => date.key)"
                                      :custom-label="opt => invoiceDueDates.find(x => x.key == opt).name"
                                      :showLabels="false"
                                      :close-on-select="true"
                                      :option-height="29"
                                      :max-height="203"
                                      style="opacity: 1"
                                      placeholder="Default Due Date"
                                      :disabled="!!settings.invoices.isXeroInvoiceDueDate || !isStatusActive"
                                  >
                                  </multiselect>
                                </div>
                              </div>
                              <!--<div class="form-group row no-gutter">
                                  <label class="col-sm-4 col-form-label">Information
                                      Included</label>
                                  <div class="col-sm-8">
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input
                                                      class="form-check-input"
                                                      v-model="settings.invoices.ii.show_tax_number"
                                                      type="checkbox"
                                                      name="ii_show_tax_number"
                                                      value="true"
                                                      @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Tax Number</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input
                                                      class="form-check-input"
                                                      v-model="settings.invoices.ii.show_col_headings"
                                                      type="checkbox"
                                                      name="ii_show_col_headings"
                                                      value="true"
                                                      @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Column Headings</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input
                                                      class="form-check-input"
                                                      v-model="settings.invoices.ii.show_item_code"
                                                      type="checkbox"
                                                      name="ii_show_item_code"
                                                      value="true"
                                                      @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Item code</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_unit_price_qty"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_unit_price_qty"
                                                     type="checkbox"
                                                     name="ii_show_unit_price_qty"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Unit Price and Quantity</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_show_payment_advice"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_show_payment_advice"
                                                     type="checkbox"
                                                     name="ii_show_show_payment_advice"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Payment Advice Cut away</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_address"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_address"
                                                     type="checkbox"
                                                     name="ii_show_address"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Address</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_tax_column"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_tax_column"
                                                     type="checkbox"
                                                     name="ii_show_tax_column"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Tax Column</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_logo"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_logo"
                                                     type="checkbox"
                                                     name="ii_show_logo"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Show Logo</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_hide_discount"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.hide_discount"
                                                     type="checkbox"
                                                     name="ii_hide_discount"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Hide Discount</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_contact_number"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_contact_number"
                                                     type="checkbox"
                                                     name="ii_show_contact_number"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Hide Contact Number</span>
                                          </label>
                                      </div>
                                      <div class="form-check">
                                          <label class="form-check-inline checkbox w-100">
                                              <input id="ii_show_payment_service"
                                                     class="form-check-input"
                                                     v-model="settings.invoices.ii.show_payment_service"
                                                     type="checkbox"
                                                     name="ii_show_payment_service"
                                                     value="true"
                                                     @change="selectInvoiceOption">
                                              <span class="icon"><i class='bx bx-check'></i></span>
                                              <span class="text">Hide Payment Service</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>-->
                              <div class="form-group row no-gutter">
                                <label for="invoice_payment_advice" class="col-sm-4 col-form-label">Terms &amp; Payment
                                  Advice</label>
                                <div class="col-sm-8 invoices-editor">
                                  <vue-editor v-model="settings.invoices.ii.advice"
                                              :editorToolbar="customToolbar"></vue-editor>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6 pl-1">
                          <div class="auto-save">
                            <div class="card-header bg-navyblue">
                              <strong>Auto Save</strong>
                            </div>
                            <div class="">
                              <label for="auto-save-button" class="col-sm-4 col-form-label"> Auto-Save</label>
                              <toggle-button
                                  v-model="settings.invoices.auto_save"
                                  id="auto-save-button"
                                  class="mb-0 rs-toggle__button"
                                  color="#5E79FF"
                                  :disabled="!isStatusActive"
                                  :sync="true"
                                  :width="40"
                                  :labels="false"/>
                              <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                                                          <template v-if="settings.invoices.auto_save">Active</template>
                                                          <template v-else>Not Active</template>
                                                      </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="isTabActive('users')" style="padding-left: 15px" id="users"
                         class="tab-pane col-lg-12 col-md-12"
                         v-bind:class="{active: isTabActive('users')}" role="tabpanel">
                      <users ref="users" :defaultPSLocId="defaultPSLocId"
                             :isActiveParssearchCode="isActiveParssearchCode"
                             :isSetDefaultPSLoc="isSetDefaultPSLoc"></users>
                    </div>
                    <div v-if="isTabActive('groups')" style="padding-left: 15px" id="groups"
                         class="tab-pane col-lg-12 col-md-12"
                         v-bind:class="{active: isTabActive('groups')}" role="tabpanel">
                      <groups ref="groups"></groups>
                    </div>
                    <div id="sms" class="tab-pane col-lg-12 col-md-12"
                         v-bind:class="{active: isTabActive('sms')}" role="tabpanel">
                      <sms v-model="settings" ref="billing"></sms>
                    </div>
                  </template>
                  <div v-if="isTabActive('my-account')" id="my-account" class="tab-pane col-lg-12 col-md-12"
                       v-bind:class="{active: isTabActive('my-account')}" role="tabpanel">
                    <my-account ref="myAccount" :defaultPSLocId="defaultPSLocId"
                                :isActiveParssearchCode="isActiveParssearchCode"
                                :isSetDefaultPSLoc="isSetDefaultPSLoc"></my-account>
                  </div>
                  <template v-if="isShopManagerUser">
                    <div v-if="isTabActive('business-profile')" id="business-profile"
                         class="tab-pane col-lg-12 col-md-12"
                         v-bind:class="{active: isTabActive('business-profile')}" role="tabpanel">
                      <div class=" ">
                        <business-profile v-model="settings"
                                          :add-location-button-pressed="isAddLocationPressed"></business-profile>
                      </div>
                    </div>
                  </template>
                  <div v-if="isTabActive('billing')" id="billing" class="tab-pane col-lg-12 col-md-12"
                       v-bind:class="{active: isTabActive('billing')}" role="tabpanel">
                    <billing v-model="settings" ref="billing" @reloadVendorSettings="loadVendorSettings"></billing>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.invoices-editor .ql-editor {
  font-size: 13px;
}

.terms-editor {
  resize: none;
  width: 100%;
  height: 205px;
  border: 1px solid #d1d1d1;
  padding: 15px;
  font-size: 13px;
  line-height: 1.6;
  word-wrap: break-word;
}

.orderNameClass {
  width: auto !important;
}

.setting-card {
  border: none !important;
}

#invoices {
  padding-left: 15px !important;
}

.setting-card > .card-header {
  border-color: red;
  border-bottom: none !important;
  padding-left: 0 !important;
  padding-top: 0 !important;
}

.V3 .setting-card .card .card-header strong {
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
}

.drag-and-drop {
  cursor: pointer;
}

input[readonly] {
  cursor: unset !important;
}

.trashBarrelClass {
  cursor: pointer;
}

.verticalTextTh {
  vertical-align: middle !important;
}


#users i {
  font-size: 20px;
  margin-left: 10px;
}

#users .ti-write {
  color: #142742;
}

#users .ti-trash {
  color: #D0021B;
}

</style>

<style>
.V3 #cards {
  padding: 0px;
}

.V3 #cards .row > div:first-child {
  padding-right: 15px;
}

.V3 #cards .card-header {
  border-radius: 3px;
}

.V3 #cards .card-block {
  padding: 15px;
}

/**
 * Table
 */
/* table global */
.V3 #cards .table .bx-plus-circle.green {
  color: #34DC6E;
}

.V3 #cards .table .form-control,
.V3 #cards .table select.form-control {
  padding-left: 9.5px;
  padding-right: 9.5px;
}

.V3 #cards .table select.form-control {
  padding-right: 25px !important;
}

/* end table global */

.V3 #cards .table.tab-special td {
  width: auto;
  margin-bottom: 20px;
  padding-top: 15px;
  padding-bottom: 9.75px;
}

.V3 #cards .table.tab-special tr {
  position: relative;
}

.V3 #cards .table .thead-light {
  background-color: rgba(27, 30, 56, 0.12);
}

/* column width */
.V3 #cards .table .twidth-order {
  width: 5%;
  min-width: 100px;
}

.V3 #cards .table .twidth-name {
  width: 20%;
  min-width: 150px;

  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
}

.V3 #cards .table .twidth-auto {
  width: 5%;
  min-width: 100px;
}

.V3 #cards .table .twidth-trigger {
  width: auto;
}

.V3 #cards .table .twidth-action {
  min-width: 75px;
  width: 10%
}

/* font style */
.V3 #cards .table .tfont-13-bold {
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: normal;
}

.V3 #cards .table .tfont-12-reguler {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: normal;
}

.V3 #cards .table .tfont-12-bold {
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: normal;
}


.V3 #cards .table .trigger-link {
  color: #1C1F39;
}

/* table icons */
.V3 #cards .table .bx {
  font-size: 20px;
  vertical-align: middle;
  position: relative;
  bottom: 2px;
  transition: transform 250ms ease-out;
}

.V3 #cards .table .active .bx-chevron-down {
  transform: rotate(180deg);
}

.V3 #cards .table .actions {
  display: flex;
  justify-content: flex-end;
}

.V3 #cards .table .actions span {
  margin-left: 15px;
}

.V3 #cards .table .actions > *:hover {
  cursor: pointer;
}

.V3 #cards .table .actions .bx-trash {
  color: #FF5E5E;
}

.V3 #cards .table .actions .bx-plus-circle {
  color: #34DC6E;
}

/* is-edit */
.V3 #cards .table .is-edit .actions .bx-pencil {
  color: #5E79FF;
}

/* animation */
.slide-row-enter-active {
  transition: all 250ms ease-out;
}

.slide-row-leave-active {
  transition: all 200ms ease-in;
}

.slide-row-enter,
.slide-row-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

/* Input Status */
.V3 #cards .setings-cards-btn-group {
  display: flex;
}

.V3 #cards .add-status-input-settings {
  vertical-align: middle;
}

.V3 #cards .add-status-button {
  flex: 0 1 83px;
  margin-left: 10px;
  border-radius: 3px;
  border-color: #5E79FF;
  box-sizing: border-box;
  color: white;
  background-color: #5E79FF;
  padding: 10px;
  font-size: 12px;
  line-height: 1em;
  font-weight: 700;
  height: 31px;
}

.V3 #cards .add-status-button:focus {
  /* box-shadow: 0 0px 10px #5E79FF; */
  border-color: #1E2F85;
}

/* status detail */
.V3 #cards .trigger {
  display: flex;
  flex-flow: column nowrap;
}

.V3 #cards .trigger__line {
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}

.V3 #cards .trigger__line .cell {
  min-width: 8px;
  margin: 0 10px;
}

.V3 #cards .trigger__line .cell:first-child {
  margin-left: 0px;
}

.V3 #cards .trigger__option {
  flex: 0 0 101px;
}

.V3 #cards .trigger__actions > * {
  margin-left: 9.5px;
}

.V3 .add-user {
  font-weight: bold !important;
}

/* card */
.V3 .card {
  margin-bottom: 0px;
}

.V3 .card-block {
  padding: 15px;
}

/* this probably can be converted to more general .tab-pane */
.tab-pane--estimates,
.tab-pane--invoices {
  max-width: 1157px;
}


@media screen and (max-width: 768px) {
  .V3 #cards .row > div:first-child {
    padding-right: 0px;
  }
}

.pin-image {
  padding-left: 35px !important;
}

@media screen and (max-width: 991px) {
  .pin-image {
    margin-bottom: 15px;
  }
}

/* Create the checkmark/indicator (hidden when not checked) */
.pin-checkmark i {
  font-size: 26px;
  color: white !important;
  margin-left: -2px !important;
  margin-top: -2px !important;
}


.V3 .setting-card .ql-toolbar {
  display: none;
}

.V3 .setting-card .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border: 1px solid rgba(28, 31, 57, 0.25);
}
</style>
